import { render, staticRenderFns } from "./PromotionHistoryPage.vue?vue&type=template&id=6d1c9c12&scoped=true"
import script from "./PromotionHistoryPage.vue?vue&type=script&lang=js"
export * from "./PromotionHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./PromotionHistoryPage.vue?vue&type=style&index=0&id=6d1c9c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c9c12",
  null
  
)

export default component.exports